<template>
  <div class="form-select" :class="[$attrs.class]" :tabindex="tabindex">
    <label v-if="$attrs.label?.length">
      <span
        class="form-select__label-wrapper"
        :class="{ 'form-select__label-wrapper--invalid': errorMessage.length }"
      >
        <span class="label-title">{{ $attrs.label }}</span>
        <span v-if="$attrs['label-optional']" class="label-subtitle">{{
          $attrs['label-optional']
        }}</span>
      </span>
    </label>
    <sl-select
      v-model="localValue"
      v-bind="$attrs"
      label=""
      hoist
      :placeholder="$attrs.placeholder"
      @keydown.tab="preventTabPropagation"
      @sl-change="handleChange"
    >
      <!-- eslint-disable-next-line vue/no-v-for-template-key -->
      <template v-for="(option, index) in options" :key="index">
        <sl-divider v-if="option.dividerTop"></sl-divider>
        <sl-option :value="option.value" :disabled="option.disabled">{{ option.text }}</sl-option>
      </template>
    </sl-select>
    <span v-if="errorMessage.length" class="form-select__error-message">{{ errorMessage }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import '@shoelace-style/shoelace/dist/components/select/select'
import '@shoelace-style/shoelace/dist/components/option/option'

defineOptions({
  inheritAttrs: false
})

const emit = defineEmits(['update:modelValue', 'onSelect'])
const props = defineProps({
  modelValue: {
    type: [String, Array],
    default: ''
  },
  error: {
    type: String,
    default: ''
  },
  options: {
    type: Array,
    default: () => []
  },
  tabindex: {
    type: String,
    default: '0'
  }
})

const errorMessage = computed(() => props.error)
const localValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

function handleChange(event) {
  emit('onSelect', event.target.value)
}

function preventTabPropagation(event) {
  if (event.key === 'Tab') {
    event.stopPropagation()
  }
}
</script>
<style src="@/components/Form/FormSelect/FormSelect.css" scoped />
